/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonHomeCountInfo = {
    STKTP: BabylonHomeCountInfo.STKTP;
    CNT: string;
    CHG24: string;
};

export namespace BabylonHomeCountInfo {

    export enum STKTP {
        BTC_STAKING = 'BTC_STAKING',
    }


}

